module.exports = __webpack_public_path__ + "static/media/DiscGuard Privacy Policy.8fefd395.pdf";